import _ from 'lodash';
import React, { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Checkbox } from '../../../../../../../../../../../lib/esm/components';
import { CheckboxItem } from '../../styles';
import { MAIN_RATING_INDICATORS } from '../../../../constants/constants';
import { ICheckboxItem } from '../../../../interfaces';

const CheckboxGroupObjectType: React.FC<{
    defaultRatingIndicators: ICheckboxItem[];
    mainIndicator: string | undefined;
    handleCheckboxsValues: (selects: ICheckboxItem[]) => void;
}> = ({ mainIndicator = '', handleCheckboxsValues, defaultRatingIndicators = MAIN_RATING_INDICATORS }) => {
    const [ratingIndicators, setValueRatingIndicators] = useState(_.cloneDeep(defaultRatingIndicators));
    const { t } = useTranslation();

    useEffect(() => {
        handleCheckboxsValues(ratingIndicators);
    }, [ratingIndicators]);

    useEffect(() => {
        setValueRatingIndicators(defaultRatingIndicators);
    }, [JSON.stringify(defaultRatingIndicators)]);

    useEffect(() => {
        setValueRatingIndicators(
            ratingIndicators.map((item) => {
                if (item.id === mainIndicator && item.checked) {
                    return { ...item, checked: false };
                } else return item;
            }),
        );
    }, [mainIndicator]);

    const checked = (s: { id?: string | undefined; checked: boolean }) => {
        setValueRatingIndicators(
            ratingIndicators.map((item) => {
                if (item.id === s.id) {
                    return { ...item, checked: s.checked };
                } else return item;
            }),
        );
    };
    const groupObjectType = useMemo(() => {
        return ratingIndicators.map((item) => {
            return (
                <CheckboxItem key={item.id}>
                    <Checkbox
                        handleToggle={checked}
                        id={item.id}
                        label={t(item.text)}
                        disabled={mainIndicator === item.id ? true : false}
                        selected={item.checked}
                    />
                </CheckboxItem>
            );
        });
    }, [ratingIndicators, mainIndicator, t]);

    return <div>{groupObjectType}</div>;
};
export default CheckboxGroupObjectType;
